let lastId = 0;

/**
 * Funkce, která generuje unikátní id, např. pro tooltipy apod.
 *
 * Použití:
 * import newId from "....newId";
 *
 * constructor(props) {
 *   super(props);
 *   this.uniqueId = newId();
 * }
 *
 * @param prefix
 * @return {string}
 */
export default function (prefix = 'id') {
    lastId++;
    return `${prefix}${lastId}`;
}
